export default {"src":"/_next/static/media/home-4.dda01662.svg","height":1523,"width":1440};